import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";
import { ootb } from "../../../Util/form-utils/typescript-44ms-ootb-all";

const formCient = React44ms.React.createClient(ootb());
(window as any).r44 = formCient;

export const FormProvider: React.FunctionComponent = (props) => {
  return (
    <React44ms.React.Provider client={formCient}>
      {props.children || []}
    </React44ms.React.Provider>
  );
};
